import { render, staticRenderFns } from "./TariffsList.vue?vue&type=template&id=7de9d420&scoped=true&"
import script from "./TariffsList.vue?vue&type=script&lang=js&"
export * from "./TariffsList.vue?vue&type=script&lang=js&"
import style0 from "./TariffsList.vue?vue&type=style&index=0&id=7de9d420&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7de9d420",
  null
  
)

export default component.exports